import { useEffect, useState } from "react";
import { Header } from "./interface/interface";
import TableStyle from "../style/table.component";
import InputStyle from "../style/input.component";
import ButtonStyle from "../style/button.component";
import { AttendanceRewardResponse } from "../../api/admin/attendance";

interface AttendanceRewardProps {
  headers: any[];
  dataList: AttendanceRewardResponse[];
  setDataList: (value: AttendanceRewardResponse[]) => void;
  save: any;
  add: any;
  remove: any;
  tableId?: number | null;
}
const AttendanceRewardTable = (props: AttendanceRewardProps) => {
  const [isWide, setIsWide] = useState(window.innerWidth > 700);
  const { headers, dataList, setDataList, save, add, remove, tableId } = props;
  const [addPoint, setAddPoint] = useState(0);
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 700) {
        setIsWide(false);
      } else {
        setIsWide(true);
      }
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return isWide ? (
    <TableStyle marginTop="30px">
      <thead>
        <tr>
          {headers.map((header: Header) => (
            <th key={header.value}>{header.text}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataList.map((data: AttendanceRewardResponse, index: number) => (
          <tr key={index}>
            {headers.map((header) => (
              <td key={header.value}>
                {header.text === "랭킹" ? (
                  data.value
                ) : header.text === "보상" ? (
                  <InputStyle
                    height="25px"
                    width="150px"
                    fontSize="13px"
                    color="white"
                    placeholder="지급할 포인트를 입력하세요."
                    value={data.value}
                    onChange={(e: any) => {
                      const newValue = Number(e.target.value);
                      let updateDataList = dataList.map(
                        (item: AttendanceRewardResponse) => {
                          if (item.id === data.id) {
                            return { ...item, value: newValue };
                          }
                          return item;
                        }
                      );
                      setDataList(updateDataList);
                    }}
                  />
                ) : (
                  <>
                    <ButtonStyle
                      fontWeight="700"
                      backgroundColor="#1976D2"
                      border="none"
                      borderRadius="7px"
                      width="85px"
                      height="25px"
                      color="white"
                      marginRight="10px"
                      onClick={() => {
                        save(data);
                      }}
                    >
                      수정
                    </ButtonStyle>
                    {index === dataList.length - 1 && (
                      <ButtonStyle
                        fontWeight="700"
                        backgroundColor="red"
                        border="none"
                        borderRadius="7px"
                        width="85px"
                        height="25px"
                        color="white"
                        marginRight="10px"
                        onClick={() => {
                          remove(data.id);
                        }}
                      >
                        삭제
                      </ButtonStyle>
                    )}
                  </>
                )}
              </td>
            ))}
          </tr>
        ))}
        <tr>
          <td>
            <InputStyle
              height="25px"
              width="150px"
              fontSize="13px"
              color="white"
              type="number"
              placeholder="지급할 포인트를 입력하세요."
              value={addPoint}
              onChange={(e: any) => {
                setAddPoint(e.target.value);
              }}
            />
          </td>
          <td>
            <ButtonStyle
              fontWeight="700"
              backgroundColor="#1976D2"
              border="none"
              borderRadius="7px"
              width="85px"
              height="25px"
              color="white"
              marginRight="10px"
              onClick={async () => {
                const item = {
                  value: +addPoint,
                  tableId,
                };
                await add(item);
                setAddPoint(0);
              }}
            >
              추가 등록
            </ButtonStyle>
          </td>
        </tr>
      </tbody>
    </TableStyle>
  ) : (
    <TableStyle setMobile={true} marginTop="30px">
      <tbody>
        {dataList.map((data: AttendanceRewardResponse, index: number) => (
          <tr key={index}>
            {headers.map((header) => (
              <td key={header.value}>
                <div>{header.text}</div>
                <td key={header.value}>
                  {header.text === "랭킹" ? (
                    header.value
                  ) : header.text === "보상" ? (
                    <InputStyle
                      height="25px"
                      width="190px"
                      fontSize="13px"
                      color="white"
                      placeholder="지급할 포인트를 입력하세요."
                      value={data.value}
                      onChange={(e: any) => {
                        const newValue = Number(e.target.value);
                        console.log("newValue:", newValue);
                        let updateDataList = dataList.map(
                          (item: AttendanceRewardResponse) => {
                            if (item.id === data.id) {
                              return { ...item, value: newValue };
                            }
                            return item;
                          }
                        );
                        setDataList(updateDataList);
                      }}
                    />
                  ) : (
                    <>
                      <ButtonStyle
                        fontWeight="700"
                        backgroundColor="#1976D2"
                        border="none"
                        borderRadius="7px"
                        width="85px"
                        height="25px"
                        color="white"
                        marginRight="10px"
                        onClick={() => {
                          save(data);
                        }}
                      >
                        수정
                      </ButtonStyle>
                      {index === dataList.length - 1 && (
                        <ButtonStyle
                          fontWeight="700"
                          backgroundColor="red"
                          border="none"
                          borderRadius="7px"
                          width="85px"
                          height="25px"
                          color="white"
                          marginRight="10px"
                          onClick={() => {
                            remove(data.id);
                          }}
                        >
                          삭제
                        </ButtonStyle>
                      )}
                    </>
                  )}
                </td>
              </td>
            ))}
          </tr>
        ))}
        <tr>
          <td>
            <div>일자</div>
            <td>{dataList.length + 1}</td>
          </td>
          <td>
            <div>포인트</div>
            <td>
              <InputStyle
                height="25px"
                color="white"
                value={addPoint}
                onChange={(e: any) => {
                  setAddPoint(e.target.value);
                }}
              />
            </td>
          </td>
          <td>
            <div></div>
            <td>
              <ButtonStyle
                fontWeight="700"
                backgroundColor="#1976D2"
                border="none"
                borderRadius="7px"
                width="85px"
                height="25px"
                color="white"
                marginRight="10px"
                onClick={async () => {
                  const item = {
                    value: addPoint,
                    tableId,
                  };
                  const result = await add(item);
                  if (result) {
                    setAddPoint(0);
                  }
                }}
              >
                추가 등록
              </ButtonStyle>
            </td>
          </td>
        </tr>
      </tbody>
    </TableStyle>
  );
};

export default AttendanceRewardTable;
